module.exports = __webpack_public_path__ + "static/media/header-bidding-icon.ebcd77bd.svg";